// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "fancybox" + "." + "7a236875b8275363d246" + ".css";
};